import i18n from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, Field } from 'formik';
import useStyles from './PilotItem.styles';
import TextField from '../../../../../../common/components/fields/TextField';
import { IconButton } from '../../../../../../common/components/buttons';
import { Icon } from '../../../../../../common/components/icons';
import Can from '../../../../../../common/contexts/abilityContext';

const PilotItem = ({ index, onDelete }) => {
  const classes = useStyles();

  const { values } = useFormikContext();

  const handleDeleteClick = () => onDelete(index);

  return (
    <div className={classes.root}>
      <Field type="hidden" name={`pilots.${index}.id`} />
      <TextField className={classes.textField} name={`pilots.${index}.name`} placeholder={i18n.t('client.form.name')} />
      <TextField className={classes.textField} name={`pilots.${index}.licenseNumber`} placeholder={i18n.t('client.form.licenseNumber')} />
      {index !== values.pilots.length - 1 && (
        <Can do="delete" on={`pilots.${index}`}>
          <IconButton onClick={handleDeleteClick}>
            <Icon icon="delete" />
          </IconButton>
        </Can>
      )}
    </div>
  );
};

PilotItem.propTypes = {
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
};

PilotItem.defaultProps = {};

export default PilotItem;
